import { marked } from "marked";

import DOMPurify from "dompurify";

// The markdown exported by fare harbor is, in many cases, dumb.
// We need to manually parse a bunch of stuff before passing it to marked parser.
// As we get more and more content from fare harbor, we will probably need to keep adding

const renderMarkdown = async (markdown: string): Promise<string> => {
  if (!markdown) return "";
  let md = markdown;

  // Replace \n with  {tab tab} \n for some reason that fixes the line breaks:
  // https://i.kym-cdn.com/entries/icons/original/000/018/489/nick-young-confused-face-300x256-nqlyaa.jpg
  md = md.replace(/\\n/g, "   \n");
  md = md.replace(/###/g, "### ");
  md = md.replace(/\\n##/g, "## ");
  md = md.replace(/"#/g, "# ");

  //replace every '##' with '## '
  md = md.replace(/##/g, "## ");

  //if string starts with " remove it
  if (md.startsWith('"')) {
    md = md.slice(1);
  }

  // if string ends with " remove it
  if (md.endsWith('"')) {
    md = md.slice(0, -1);
  }

  const rawHtml = await marked.parse(md);

  // ⚠️ IMPORTANT sanitize the html to protect against XSS attacks
  return DOMPurify.sanitize(rawHtml);
};

export default renderMarkdown;
